angular.module('env.custom.customModule.orderFiles', [])

    .controller('orderFilesController', function ($window, $compile, $log, $q, $scope, gettextCatalog, toastr,
                                                  authService, documentsRepository, threejsLoader, meshViewerDataService, fileService) {

        $scope.loadingFile = true;

        $scope.$on('$destroy', function () {
            //watcherDestructor();
        });

        var meshViewerFormWidth = 0.8; //meaning percentage 80%
        var meshViewerFormHeight = 0.8; //meaning percentage 80%

        $scope.view3dModel = function(document) {

            var windowTitle = gettextCatalog.getString("Model preview: ") + (document.$model.fileName.length < 40 ? document.$model.fileName : 
                document.$model.fileName.substr(0, 20) + "..." + document.$model.fileName.substr(document.$model.fileName.length - 17));

            $scope.meshViewerWindowOptions = {
                animation: om.config.kendoWindowDefaultOptions.animation,
                actions: ["Close"],
                modal: true,
                draggable: false,
                resizable: false,
                width: (meshViewerFormWidth * 100) + "%",
                height: (meshViewerFormHeight * 100) + "%",
                visible: false,
                title: windowTitle,
                open: $scope.onMeshViewerOpen,
                close: $scope.onMeshViewerClose
            };

            $scope.document = document;
            //Save document file name for later usage
            $scope.documentFileName = document.$model.fileName;

            //And then
            //Bring up kendoui window with the mesh viewer in it (initialised with the document data)
            if ($scope.meshViewerWindow) {
                destroyMeshViewerWindow();
            }
            $scope.meshViewerScope = $scope.$new(false);
            $scope.meshViewerWindow = 
                $($compile("<div id='meshViewerForm'>" + 
                    "<div class='k-loading-mask fade fade-out' ng-class='{in:loadingFile}'><span om-spinner size='1.6em'></span></div>" + 
                    "<mesh-viewer bounding-box-color='#32A9D9' scene-background-color='#c7c7c7' " + 
                      "style='height:100%;width:100%;' class='fade fade-out' ng-class='{in:!loadingFile && !fileLoadError}'></mesh-viewer>" + 
                    "</div>")($scope.meshViewerScope))
                .kendoWindow($scope.meshViewerWindowOptions);
            
            //Update mesh viewer window options to update its size and position according to current browser window size
            $scope.meshViewerWindow.data("kendoWindow").center();
            $scope.meshViewerWindow.data("kendoWindow").open();

            //Re-center kendo window on browser window resize
            angular.element($window).bind('resize', function() {
                if ($scope.meshViewerWindow) {
                    $scope.meshViewerWindow.data("kendoWindow").center();
                }
            });
        };

        $scope.onMeshViewerClose = function() {
            destroyMeshViewerWindow();
        }

        $scope.onMeshViewerOpen = function() {
            $scope.loadingFile = true;

            fileService
                .downloadDocumentFile($scope.document.$model.id)
                .then(addFileTo3dViewer);
        }

        function destroyMeshViewerWindow() {
            meshViewerDataService.clearGeometries();
            meshViewerDataService.destroy();

            $scope.meshViewerWindow.data("kendoWindow").destroy();
            $scope.meshViewerWindow.remove();
            delete $scope.meshViewerWindow;

            if ($scope.meshViewerScope) {
                $scope.meshViewerScope.$destroy();
            }
        }

        function addFileTo3dViewer(file) {
            //Assign file name to the file object so the parser will use the file extension to infer the proper viewing engine
            file.name = $scope.documentFileName;

            return threejsLoader
                .parseFile(file)
                .then(function (geometry) {
                    if (!geometry) {
                        throw new Error('Geometry data empty.');
                    }

                    $scope.$applyAsync(function () { $scope.loadingFile = false; });

                    meshViewerDataService.clearGeometries();

                    return meshViewerDataService.addGeometry(geometry);
                }, function (err) {
                    handleError("Unable to parse 3D model file", err);
                })
                .catch(function (err) {
                    handleError("Unable to render 3D model file", err);
                });
        }

        function handleError(errorMessage, error) {
            toastr.error(null, gettextCatalog.getString(errorMessage));
            $log.error(errorMessage, error);

            $scope.$applyAsync(function () { $scope.loadingFile = false; $scope.fileLoadError = true;});

            if ($scope.meshViewerWindow) {
                $scope.meshViewerWindow.data("kendoWindow").close();
            }
        }

    });
